// extracted by mini-css-extract-plugin
export default {"main":"_78dbef4a62 _82103b799b","xmark":"d0e87457f8","fl_img":"_03211bb60b db8d283182"};